import { Route, Router, Switch } from 'react-router';
import * as React from 'react';
import Page404 from './modules/404/Page404';
import AccioAccreditationComponent from './modules/accreditations/AccioAccreditation.component';
import CnmvAccreditationComponent from './modules/accreditations/CnmvAccreditation.component';
import FaqComponent from './modules/faq/Faq.component';
import TermsAndConditionsComponent from './modules/terms-and-conditions/TermsAndConditions.component';
import HowToInvestContainer from './modules/how-to-invest/HowToInvest.container';
import InvestContainer from './modules/invest/Invest.container';
import ContactContainer from './modules/contact/Contact.container';
import OurTeamComponent from './modules/our-team/index/OurTeam.component';
import TeamMemberComponent from './modules/our-team/show/TeamMember.component';
import MyProfileIndexContainer from './modules/my-account/my-profile-index/MyProfileIndex.container';
import PhysicalPersonUpdateContainer from './modules/my-account/physical-person-update/PhysicalPersonUpdate.container';
import ChangePasswordContainer from './modules/my-account/change-password/ChangePassword.container';
import { history } from './store';
import ProjectsComponent from './modules/projects/Projects.component';
import InvestorTypesContainer from './modules/my-account/investor-types/InvestorTypes.container';
import TestInvestorTypeContainer
  from './modules/my-account/investor-types/aptitude-test/AptitudeTestInvestorType.container';
import ConfirmAccreditedInvestorTypeContainer
  from './modules/my-account/investor-types/partials/ConfirmAccreditedInvestorType.container';
import AptitudeTestResultsInvestorTypeContainer
  from './modules/my-account/investor-types/aptitude-test/AptitudeTestResultsInvestorType.container';
import ShowProjectContainer from './modules/project/ShowProject.container';
import IsLoggedRoute from './modules/commons/is-logged-route/IsLoggedRoute';
import JuridicalPersonUpdateContainer
  from './modules/my-account/juridical-profile-update/JuridicalPersonUpdate.container';
import MyPortfolioContainer from './modules/my-portfolio/MyPortfolio.container';
import ProjectUpdateContainer from './modules/project/update/ProjectUpdate.container';
import PrivateRoute from 'src/modules/commons/private-route/PrivateRoute';
import MyProjectsListContainer from './modules/projects/my-projects/MyProjectsList.container';
import ShowInvestorDeckContainer from 'src/modules/investor-deck/ShowInvestorDeck.container';
import HomeContainer from './modules/home/Home.container';
import InvestorDeckContainer from 'src/modules/investor-deck/partials/InvestorDeckSteps.container';
import PasswordResetContainer from './modules/password-reset/PasswordReset.container';
import CookiesPoliciesComponent from 'src/modules/privacy-and-cookies/CookiesPolicies.component';
import PrivacyPoliciesComponent from 'src/modules/privacy-and-cookies/PrivacyPolicies.component';
import CustomerInformationComponent from 'src/modules/customer-information/CustomerInformation.component';

export default (
  <Router history={history}>
    <Switch>
      <Route
        exact={true}
        path="/acreditacion-accio"
        component={AccioAccreditationComponent}
      />
      <Route
        exact={true}
        path="/acreditacion-cnmv"
        component={CnmvAccreditationComponent}
      />
      <Route
        exact={true}
        path="/contacto"
        component={ContactContainer}
      />
      <Route
        exact={true}
        path="/faq"
        component={FaqComponent}
      />
      <Route
        exact={true}
        path="/terminos-y-condiciones"
        component={TermsAndConditionsComponent}
      />
      <Route
        exact={true}
        path="/politica-de-cookies"
        component={CookiesPoliciesComponent}
      />
      <Route
        exact={true}
        path="/politica-de-privacidad"
        component={PrivacyPoliciesComponent}
      />
      <Route
        exact={true}
        path="/informacion-basica"
        component={CustomerInformationComponent}
      />
      <Route
        exact={true}
        path="/como-invertir"
        component={HowToInvestContainer}
      />
      <Route
        exact={true}
        path="/invertir"
        component={InvestContainer}
      />
      <Route
        exact={true}
        path="/nuestro-equipo"
        component={OurTeamComponent}
      />
      <Route
        exact={true}
        path="/nuestro-equipo/:teamMember"
        component={TeamMemberComponent}
      />
      <Route
        exact={true}
        path="/muestrario-de-operaciones"
        component={ProjectsComponent}
      />
      <Route
        exact={true}
        path="/como-financiar-tu-startup"
        component={ShowInvestorDeckContainer}
      />
      <IsLoggedRoute
        exact={true}
        path="/investor-deck"
      >
        <Route
          exact={true}
          path="/investor-deck"
          component={InvestorDeckContainer}
        />
      </IsLoggedRoute>
      <Route
        exact={true}
        path="/ficha-de-operaciones/:projectId/:invest?"
        component={ShowProjectContainer}
      />
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/perfil"
      >
        <Route
          exact={true}
          path="/mi-cuenta/perfil"
          component={MyProfileIndexContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/cambiar-contrasena"
      >
        <Route
          exact={true}
          path="/mi-cuenta/cambiar-contrasena"
          component={ChangePasswordContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/perfil/fisico/editar"
      >
        <Route
          exact={true}
          path="/mi-cuenta/perfil/fisico/editar"
          component={PhysicalPersonUpdateContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/perfil/juridico/editar/:personId"
      >
        <Route
          exact={true}
          path="/mi-cuenta/perfil/juridico/editar/:personId"
          component={JuridicalPersonUpdateContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/perfil/juridico/editar"
      >
        <Route
          exact={true}
          path="/mi-cuenta/perfil/juridico/editar"
          component={JuridicalPersonUpdateContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/tipo-de-inversor"
      >
        <Route
          exact={true}
          path="/mi-cuenta/tipo-de-inversor"
          component={InvestorTypesContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/tipo-de-inversor/test"
      >
        <Route
          exact={true}
          path="/mi-cuenta/tipo-de-inversor/test"
          component={TestInvestorTypeContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/tipo-de-inversor/acreditado/resultados"
      >
        <Route
          exact={true}
          path="/mi-cuenta/tipo-de-inversor/acreditado/resultados"
          component={AptitudeTestResultsInvestorTypeContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cuenta/tipo-de-inversor/acreditado/confirmar"
      >
        <Route
          exact={true}
          path="/mi-cuenta/tipo-de-inversor/acreditado/confirmar"
          component={ConfirmAccreditedInvestorTypeContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-cartera"
      >
        <Route
          exact={true}
          path="/mi-cartera"
          component={MyPortfolioContainer}
        />
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-empresa/editar/:projectId"
      >
        <PrivateRoute
          exact={true}
          path="/mi-empresa/editar/:projectId"
          permissions={[{type: 'projectFounder'}]}
        >
          <Route
            exact={true}
            path="/mi-empresa/editar/:projectId"
            component={ProjectUpdateContainer}
          />
        </PrivateRoute>
      </IsLoggedRoute>
      <IsLoggedRoute
        exact={true}
        path="/mi-empresa"
      >
        <Route
          exact={true}
          path="/mi-empresa"
          component={MyProjectsListContainer}
        />
      </IsLoggedRoute>
      <Route
        exact={true}
        path="/reset-password/:resetToken"
        component={PasswordResetContainer}
      />
      <Route
        exact={true}
        path="/"
        component={HomeContainer}
      />
      <Route component={Page404} />
    </Switch>
  </Router>
);



// WEBPACK FOOTER //
// ./src/Router.tsx